/**
 * Typed wrappers for the authentication endpoints.
 *
 * Follows the wrapped-service-function pattern established in #383 rather
 * than calling `authFetch` with a hardcoded URL from the component layer.
 *
 * Contains: logoutOnServer.
 */

import config from '../../config/environment';

/**
 * End the session server-side: blacklist the refresh token and clear its
 * HttpOnly cookie.
 *
 * Deliberately never rejects. The caller clears local state regardless, so
 * a network failure must not leave the user looking logged in — the worst
 * case is a refresh token that stays valid until it expires on its own.
 *
 * Does not go through `apiClient`: that would try to refresh a 401 and could
 * recurse back into logout. Logout needs the cookie and nothing else.
 */
export async function logoutOnServer(): Promise<void> {
  try {
    await fetch(`${config.apiUrl}/api/users/logout/`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: '{}',
    });
  } catch {
    // Offline, or the API is unreachable. Nothing useful to do — local
    // state is cleared by the caller either way.
  }
}
